import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { GridImpl } from "./grid.styles.es.js";
const propTypes = {
  alignX: PropTypes.oneOf(["left", "center", "right", "justify"]),
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  columnWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  space: PropTypes.oneOf(["none", "small", "medium", "large"])
};
const defaultProps = {
  alignX: "left",
  as: void 0,
  space: "large"
};
const Grid = ({ alignX, as, children, columnWidth, space }) => /* @__PURE__ */ jsx(GridImpl, { as, $alignX: alignX, $columnWidth: columnWidth, $space: space, children });
Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
export {
  Grid
};
